var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cprm-btn",attrs:{"disabled":_vm.disabled,"data-type":_vm.type,"data-icon":_vm.icon}},[(_vm.icon)?_c('img',{attrs:{"src":"","alt":""}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }